export default __webpack_public_path__ + "static/media/pending-user-notification.4f5a3b8e.wav";